import { useSelector } from 'react-redux';
import { campaignsSelector, hydratedSelector } from '../ducks/selectors';

import Carousel from '~/components/carousel/carousel-async';

const CasinoCarousel = () => {
	const isHydrated = useSelector(hydratedSelector);
	const campaigns = useSelector(campaignsSelector);

	return campaigns?.length ? <Carousel campaigns={campaigns} isHydrated={isHydrated} /> : null;
};

export default CasinoCarousel;
